import MainLayout from 'client/common/components/main-layout';

import './index.css';

export default MainLayout;
